import { Box, Typography, useTheme } from "@mui/material";
import { OcRoleFilterSummaryItemProps } from "./role-filter-summary-item";
import { useOcIsMobile } from "oc/hooks";

type OcRoleFilterSummaryItemViewProps = Omit<
  OcRoleFilterSummaryItemProps,
  "color"
> & {
  color: NonNullable<OcRoleFilterSummaryItemProps["color"]>;
};
export const OcRoleFilterSummaryItemView = ({
  color,
  label,
  value,
}: OcRoleFilterSummaryItemViewProps) => {
  const theme = useTheme();
  const isMobile = useOcIsMobile();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography
        variant="body1"
        paddingRight="16px"
        color={theme.palette.owGray.main}
        sx={{
          display: "flex",
          width: isMobile ? "100%" : "50%",
          justifyContent: isMobile ? "center" : "end",
          textAlign: "center",
        }}
      >
        {label}
      </Typography>
      <Typography
        variant="h4"
        paddingLeft="4px"
        color={color}
        width="50%"
      >
        {value}
      </Typography>
    </Box>
  );
};
